import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { start, trackPageView } from './gtag.js';
import { pagePath } from './pagePath.js';

/**
 * Starts analytics and counts a page view per navigation.
 *
 * Called once from the app root. Two effects rather than one because they run
 * on different schedules — the loader once, the counter on every route change
 * — and React runs them in declaration order on mount, which is the ordering
 * this needs: gtag has to exist before the first view is sent to it.
 *
 * GA4's own page-view tracking is switched off in `start`, because it reads
 * the URL at load time and a single-page app changes the URL without
 * reloading. Left to itself it would count the entry page once and every
 * screen after it never.
 */
export function useAnalytics(): void {
  const location = useLocation();

  useEffect(() => {
    start();
  }, []);

  useEffect(() => {
    trackPageView(pagePath(location.pathname, location.search));
  }, [location.pathname, location.search]);
}
